import { isEpgProgramParentalBlocked, type EpgProgramWithRatings } from './parentalControl';

export type EpgPlaybackBlockReason = 'subscription' | 'parental';

export const getEpgPlaybackBlockReason = (
    program: EpgProgramWithRatings,
    isLockedProgram: boolean
): EpgPlaybackBlockReason | null => {
    if (isLockedProgram) {
        return 'subscription';
    }
    if (isEpgProgramParentalBlocked(program)) {
        return 'parental';
    }
    return null;
};
